import { useRealTimeStore } from '@hotjar/webapp/features/Playbacks/store/realTimeStore';
import type { Store } from '../../../store/player/types';

/**
 * Set the IFrame content for the page
 */
export const setCurrentIframeContent = (store: Store, page?: number, refresh = false): void => {
  const {
    playbackScript,
    currentPageIndex,
    recording,
    startPageContentIdentifier,
    setStartPageContentIdentifier,
    setLastTickTime,
    storeIframeLoadTime,
    setCurrentPageOriginalUrl,
  } = store.getState();
  if (!recording || !playbackScript) return;

  playbackScript.clearTrail();

  const activePage = page || currentPageIndex;
  const pvr = recording.page_visit_recordings[activePage];

  setLastTickTime(null); // We don't want to log page switch time.

  if (startPageContentIdentifier !== pvr.start_page_content_identifier || refresh) {
    setStartPageContentIdentifier(pvr.start_page_content_identifier);
    storeIframeLoadTime();

    playbackScript.run(
      activePage,
      pvr.start_page_content_identifier,
      startPageContentIdentifier,
      recording.id,
      recording.device,
      useRealTimeStore.getState().currentTime,
    );
  }

  setCurrentPageOriginalUrl(pvr.page_url);
};
